import * as types from "../types/token"

const initialState = {
  accessToken: null,
  refreshToken: null
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_TOKENS:
      return action.tokens
    case types.DELETE_TOKENS:
      return { accessToken: null, refreshToken: null }
    default:
      return state
  }
}

export default userReducer